import { Component, OnInit, Inject, inject } from "@angular/core";
import { FormBuilder, FormGroup, Validators, FormArray } from "@angular/forms";
import { EquipmentType } from "../models/equipment-type";
import { WebStorageService, LOCAL_STORAGE } from "ngx-webstorage-service";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { SuccessDialogComponent } from "../success-dialog/success-dialog.component";
import { Category } from "../models/category";
import { StandardService } from "../services/standard.service";
import { EquipmentStandardService } from "../services/equipment -standard.service";
import { LocationType } from "../models/location-type";
import { EquipmentStandard } from "../models/equipment-standard";
import {
  EquipmentClassEnum,
  MasterDataRequestedType,
  LocationTypeEnum,
  UserRoleEnum,
} from "../core/constant";
import { CategoryEnum } from "../core/constant";
import { FilterList } from "../models/filterList";
import { Observable } from "rxjs";
import { CryptographyService } from "../services/cryptography.service";
import { Supplier } from "../models/supplier";
import { ActivatedRoute, Router } from "@angular/router";
import { SimpleModalService } from "ngx-simple-modal-eq";
import { ImageCroppedEvent } from "ngx-image-cropper";
import { ModalImageCropperComponent } from "../modal-image-cropper/modal-image-cropper.component";
import { FailModuleComponent } from "../fail-module/fail-module.component";
import { SubLocationType } from "../models/sub-location-type";
import { Country } from "../models/country";
import { core } from "@angular/compiler";
import { Step } from "../stepper/stepper.component";
import { STEPPER_GLOBAL_OPTIONS } from "@angular/cdk/stepper";
import { MatStepper } from "@angular/material/stepper";
import { StepperSelectionEvent } from "@angular/cdk/stepper";
import { log } from "console";
import { IDropdownSettings } from "ng-multiselect-dropdown";
import { DomSanitizer, SafeHtml } from "@angular/platform-browser";
import { MatSnackBar } from "@angular/material/snack-bar";
import { SnackbarComponent } from "../snackbar/snackbar.component";
import DOMPurify from "dompurify";

interface ResourceLink {
  id: number;
  url: string;
  description: string;
}
@Component({
  selector: "app-add-equipment-standard",
  templateUrl: "./add-equipment-standard.component.html",
  styleUrls: ["./add-equipment-standard.component.scss"],
  providers: [
    {
      provide: STEPPER_GLOBAL_OPTIONS,
      useValue: { showError: true, displayDefaultIndicatorType: false },
    },
  ],
})
export class AddEquipmentStandardComponent implements OnInit {
  private _snackBar = inject(MatSnackBar);

  error: boolean = false;
  errorMessage: string = "";
  startTime: Date | null = null;
  endTime: Date | null = null;
  newCreatedStandard: any = [];
  promptMessage = "";
  loading: boolean = false;
  userRole: number;
  addEquipmentStandardForm: FormGroup;
  equipmentTypes: EquipmentType[] = [];
  invalidImage: boolean = false;
  invalidAttachment: boolean = false;
  invalidImageRes: boolean = false;
  isEditMode: boolean = false;
  subLocationTypes: SubLocationType[] = [];
  countries: Country[] = [];
  locationTypes: LocationType[] = [];
  categories: Category[] = [];
  filteredCategories: Category[] = [];
  suppliers: Supplier[] = [];
  equipmentStandard: EquipmentStandard = new EquipmentStandard();
  get equipmentClassEnum() {
    return EquipmentClassEnum;
  }
  get categoryEnum() {
    return CategoryEnum;
  }
  imageChangedEvent: any = "";

  formSteps: Step[] = [
    { id: 0, title: "Basic Info", status: "active" },
    { id: 1, title: "Location & Images", status: "inactive" },
    { id: 2, title: "Supporting Info", status: "inactive" },
    { id: 3, title: "Review & Submit", status: "inactive" },
  ];

  LocationsdropdownList = [];
  selectedLocations: any[] = [];
  dropdownSettings: IDropdownSettings;

  sublocationDropdownList = [];
  subLocationselected = [];
  subLocationdropdownSettings: IDropdownSettings;

  equipMentDropdownList = [];
  selectedEquipmentType = [];
  equipmentdropdownSettings: IDropdownSettings;

  supplierDropdownList = [];
  selectedSupplier = [];
  supplierdropdownSettings: IDropdownSettings;
  resourceId = 1;
  currentSTepIndex: number = 0;

  step0Group: FormGroup;
  step1Group: FormGroup;
  step2Group: FormGroup;
  step3Group: FormGroup;
  step4Group: FormGroup;

  lastPageEquipmentType: string;
  lastPageSupplier: string;
  createdOn: Date;
  detailsExpanded: boolean = false;
  lastPageSublocation: string;

  // resourceLinks: ResourceLink[] = [
  //   { id: this.resourceId++, url: "", description: "" },
  // ];
  // addLink(): void {
  //   this.resourceLinks.push({
  //     id: this.resourceId++,
  //     url: "",
  //     description: "",
  //   });
  // }
  // removeLink(link: ResourceLink): void {
  //   if (this.resourceLinks.length === 1) {
  //     link.url = "";
  //     link.description = "";
  //   } else {
  //     if (link.url || link.description) {
  //       link.url = "";
  //       link.description = "";
  //     } else {
  //       this.resourceLinks = this.resourceLinks.filter(
  //         (item) => item.id !== link.id
  //       );
  //     }
  //   }
  // }

  pasteLink(link) {
    void 0;
    if (navigator.clipboard) {
      navigator.clipboard
        .readText()
        .then((text) => {
          if (text.includes("mcd.com")) {
            link.get("url").setValue(text);
            void 0;
            const url = link.get("url")?.value;
            const title = link.get("title")?.value;
            if (title && url) {
              this.addEquipmentStandardForm
                .get("linksFieldValid")
                ?.clearValidators();
              this.addEquipmentStandardForm
                .get("linksFieldValid")
                ?.updateValueAndValidity();
            } else {
              this.addEquipmentStandardForm
                .get("linksFieldValid")
                ?.setValidators(Validators.required);
              this.addEquipmentStandardForm
                .get("linksFieldValid")
                ?.updateValueAndValidity();
            }
          } else {
            alert("not a valid URL");
          }
        })
        .catch((err) => {
          console.error("Failed to read clipboard: ", err);
        });
    } else {
      alert("Clipboard API not supported in this browser.");
    }
  }
  openLink(url: string) {
    if (url && url.trim() !== "") {
      const validUrl =
        url.startsWith("http://") || url.startsWith("https://")
          ? url
          : "https://" + url;

      window.open(validUrl, "_blank");
    } else {
      alert("No valid link provided!");
    }
  }

  constructor(
    private fb: FormBuilder,
    private equipmentStandardService: EquipmentStandardService,
    private ngbModal: NgbModal,
    @Inject(LOCAL_STORAGE) private storage: WebStorageService,
    private standardService: StandardService,
    private cryptographyService: CryptographyService,
    private activeRoute: ActivatedRoute,
    private router: Router,
    private SimpleModalService: SimpleModalService,
    private sanitizer: DomSanitizer,
  ) {
    const rawParam =
      this.activeRoute.snapshot.paramMap.get("standardId") ||
      this.activeRoute.snapshot.paramMap.get("id");
    if (rawParam) {
      this.equipmentStandard.standardId = parseInt(rawParam);
    }
  }

  ngOnInit() {
    this.equipmentdropdownSettings = {
      closeDropDownOnSelection: true,
      singleSelection: true,
      idField: "id",
      textField: "name",
      selectAllText: "Select All",
      unSelectAllText: "UnSelect All",
      itemsShowLimit: 1,
      allowSearchFilter: true,
    };
    this.dropdownSettings = {
      singleSelection: false,
      idField: "id",
      textField: "name",
      selectAllText: "Select All",
      unSelectAllText: "UnSelect All",
      itemsShowLimit: 6,
      allowSearchFilter: true,
    };
    if (this.equipmentStandard.standardId) {
      this.isEditMode = true;
      this.loading = true;
      this.equipmentStandardService
        .getEquipmentStandardByStandardId(this.equipmentStandard.standardId)
        .subscribe((data: EquipmentStandard) => {
          this.equipmentStandard = new EquipmentStandard(data);
          if (this.equipmentStandard.imageAttachment) {
            const imgAtt = this.equipmentStandard.imageAttachment;
            if (imgAtt.attachmentContentAsBase64) {
              this.equipmentStandard.imageAttachmentContentAsBase64 = imgAtt.attachmentContentAsBase64;
            } else if (imgAtt.attachmentContent) {
              let mime = imgAtt.mime || "data:image/png;base64,";
              if (!mime.startsWith("data:")) {
                mime = "data:" + mime;
              }
              if (!mime.includes(";base64,")) {
                mime = mime + ";base64,";
              }
              this.equipmentStandard.imageAttachmentContentAsBase64 = mime + imgAtt.attachmentContent;
            } else if (imgAtt.image) {
              this.equipmentStandard.imageAttachmentContentAsBase64 = imgAtt.image;
            }
          }
          // getMasterData() already loads the full dropdown lists for both add
          // and edit here, but nothing was pre-selecting this standard's own
          // equipment type/supplier/location in them - the hidden form control
          // got the right id, but the dropdown chip itself stayed empty.
          this.selectedEquipmentType = this.equipmentStandard.equipmentType
            ? [this.equipmentStandard.equipmentType]
            : [];
          this.selectedSupplier = this.equipmentStandard.supplier
            ? [this.equipmentStandard.supplier]
            : [];
          this.selectedLocations = this.equipmentStandard.locationType
            ? [this.equipmentStandard.locationType]
            : [];
          this.setControlsValue();
          this.loading = false;
        });
    }
    this.createdOn = new Date();
    this.getMasterData();
    this.createForm();
    this.addLinks();
  }

  showSublocationField() {
    try {
      if (
        this.addEquipmentStandardForm.controls.locationTypeId.value.includes(8)
      ) {
        return true;
      }
    } catch (error) {
      /* error may occur when locationTypeId is not an array */
      return false;
    }
  }

  getMasterData() {
    this.loading = true;
    this.standardService
      .GetMasterDataForAddEditStandard(
        MasterDataRequestedType.AddGlobalEquipmentStandard,
      )
      .subscribe((data: any) => {
        this.locationTypes = data.locationTypes.map(
          (ob) => new LocationType(ob),
        );
        this.LocationsdropdownList = this.locationTypes;
        this.equipmentTypes = data.equipmentTypes.map(
          (ob) => new EquipmentType(ob),
        );

        this.equipMentDropdownList = this.equipmentTypes;

        this.suppliers = data.suppliers.map((ob) => new Supplier(ob));
        this.supplierDropdownList = this.suppliers;
        this.loading = false;
      });

    if (
      this.cryptographyService.decryptData(this.storage.get("userRole")) !=
      UserRoleEnum.AOWAdmin
    ) {
      this.equipmentStandardService
        .getMarketSuppliersByCountryId(
          this.cryptographyService.decryptData(this.storage.get("countryId")),
        )
        .subscribe((data: any) => {
          this.suppliers = data.map((ob) => new Supplier(ob));
          this.supplierDropdownList = this.suppliers;
        });
    }

    this.standardService
      .GetMasterDataForAddNrbes(
        this.cryptographyService.decryptData(this.storage.get("userRole")),
        this.cryptographyService.decryptData(this.storage.get("userId")),
      )
      .subscribe((data: any) => {
        this.countries = data.countries;
      });
  }
  createResourceLink(): FormGroup {
    return this.fb.group({
      url: [""],
      title: [""],
    });
  }
  addLinks() {
    this.resourceLinks1.push(this.createResourceLink());
  }
  removeLink(index: number): void {
    const linkGroup = this.resourceLinks1.at(index);

    if (linkGroup) {
      const url = linkGroup.get("url")?.value;
      const desc = linkGroup.get("title")?.value;
      if (url || desc) {
        linkGroup.get("url")?.setValue("");
        linkGroup.get("title")?.setValue("");
      } else {
        if (this.resourceLinks1.length > 1) {
          this.resourceLinks1.removeAt(index);
        }
      }
    }
    const hasInvalidRow = this.resourceLinks1.controls.some((link) => {
      const url = link.get("url")?.value;
      const title = link.get("title")?.value;
      return (url && !title) || (!url && title);
    });

    const ctrl = this.addEquipmentStandardForm.get("linksFieldValid");

    if (hasInvalidRow) {
      ctrl?.setValidators(Validators.required);
    } else {
      ctrl?.clearValidators();
    }

    ctrl?.updateValueAndValidity();
  }
  onEnterResourceTitle(link: FormGroup) {
    const url = link.get("url")?.value.trim();
    const title = link.get("title")?.value.trim();
    const ctrl = this.addEquipmentStandardForm.get("linksFieldValid");

    if ((url && title) || (!url && !title)) {
      ctrl?.clearValidators();
    } else {
      ctrl?.setValidators(Validators.required);
    }

    ctrl?.updateValueAndValidity();
  }

  get resourceLinks1() {
    return this.addEquipmentStandardForm.get("resourceLinks1") as FormArray;
  }
  get hasResourceUrls(): boolean {
    return this.resourceLinks1.controls.some(
      (c) => !!c.get("url")?.value?.trim(),
    );
  }
  get selectedLocationNames(): string {
    return this.selectedLocations?.map((loc) => loc.name).join(", ") || "";
  }

  createForm() {
    this.userRole = this.cryptographyService.decryptData(
      this.storage.get("userRole"),
    );
    this.addEquipmentStandardForm = this.fb.group({
      equipmentTypeId: ["", Validators.required],
      model: ["", Validators.required],
      title: ["", Validators.required],
      description: ["", Validators.required],
      note: ["", Validators.required],
      locationTypeId: ["", Validators.required],
      subLocationTypeId: [""],
      supplierId: ["", Validators.required],
      countryId: [""],
      resourceLinks1: this.fb.array([]),
      image: ["", Validators.required],
      linksFieldValid: [""],
    });
    this.step0Group = this.fb.group(
      {
        title: this.addEquipmentStandardForm.get("title"),
        equipmentTypeId: this.addEquipmentStandardForm.get("equipmentTypeId"),
        supplierId: this.addEquipmentStandardForm.get("supplierId"),
        model: this.addEquipmentStandardForm.get("model"),
      },
      { validators: this.checkFormFieldValidations },
    );
    this.step1Group = this.fb.group(
      {
        description: this.addEquipmentStandardForm.get("description"),
        locationTypeId: this.addEquipmentStandardForm.get("locationTypeId"),
        subLocationTypeId:
          this.addEquipmentStandardForm.get("subLocationTypeId"),
        image: this.addEquipmentStandardForm.get("image"),
      },
      { validators: this.checkFormFieldValidations },
    );

    this.step2Group = this.fb.group(
      {
        note: this.addEquipmentStandardForm.get("note"),
        linksFieldValid: this.addEquipmentStandardForm.get("linksFieldValid"),
        // resourceLinks: this.addEquipmentStandardForm.get("resourceLinks1"),
      },

      { validators: this.checkFormFieldValidations },
    );
  }

  startTimer() {
    // alert("Start");
    this.startTime = new Date();
    // alert("timer started");
  }
  endTimer() {
    if (!this.startTime) {
      console.error("Start time is not set.");
      return;
    }
    this.endTime = new Date();
    const timeDiff = this.endTime.getTime() - this.startTime.getTime();
    const seconds = timeDiff / 1000;
    // alert("timer stopped");
    return seconds;
  }

  save() {
    this.startTimer();
    this.loading = true;
    this.newCreatedStandard = [];
    this.equipmentStandard.categoryId = this.categoryEnum.Equipment;
    this.equipmentStandard.description =
      this.addEquipmentStandardForm.controls.description.value;
    this.equipmentStandard.equipmentTypeId =
      this.addEquipmentStandardForm.controls.equipmentTypeId.value;
    ((this.equipmentStandard.locationTypeId =
      this.addEquipmentStandardForm.controls.locationTypeId.value),
      (this.equipmentStandard.subLocationTypeId = this.addEquipmentStandardForm
        .controls.subLocationTypeId
        ? this.addEquipmentStandardForm.controls.subLocationTypeId.value
        : null));
    void 0;
    this.equipmentStandard.supplierId =
      this.addEquipmentStandardForm.controls.supplierId.value;
    this.equipmentStandard.model =
      this.addEquipmentStandardForm.controls.model.value;
    this.equipmentStandard.note =
      this.addEquipmentStandardForm.controls.note.value;
    this.equipmentStandard.title =
      this.addEquipmentStandardForm.controls.title.value;
    this.equipmentStandard.equipmentClassTypeId = this.equipmentClassEnum.Local;

    const links = this.addEquipmentStandardForm.controls.resourceLinks1.value;

    this.equipmentStandard.links = links.filter(
      (link) => link.url?.trim() || link.title?.trim(),
    );
    // this.equipmentStandard.links =
    //   this.addEquipmentStandardForm.controls.resourceLinks1.value;
    if (this.addEquipmentStandardForm.controls.countryId.value == 0 || null) {
      this.equipmentStandard.countryId = this.cryptographyService.decryptData(
        this.storage.get("countryId"),
      );

      void 0;
    } else {
      this.equipmentStandard.countryId =
        this.addEquipmentStandardForm.controls.countryId.value;
    }
    this.equipmentStandard.createdUserId = this.cryptographyService.decryptData(
      this.storage.get("userId"),
    );
    this.equipmentStandard.imageFileName =
      this.equipmentStandard.imageAttachment.fileName;
    if (this.equipmentStandard.equipmentAttachment != undefined) {
      this.equipmentStandard.attachmentFileName =
        this.equipmentStandard.equipmentAttachment.fileName;
      this.equipmentStandard.attachmentContentAsBase64 =
        this.equipmentStandard.equipmentAttachment.attachmentContentAsBase64;
    }
    if (this.equipmentStandard.standardId) {
      this.updateStandard(this.equipmentStandard).subscribe((data) => {
        this.newCreatedStandard.push({
          name: this.equipmentStandard.title,
          totalTime: this.endTimer(),
          eventType: "NewStandardsPROD",
          status: "Modified",
          standardType: "MarketEquipmentStandard",
          session: JSON.parse(localStorage.getItem("NRBA_SESSION")).value,
          error: this.error,
          errorMessage: "No error",
        });
        void 0;
        this.standardService
          .recordEvent(this.newCreatedStandard)
          .subscribe({ next: () => void 0, error: () => void 0 });
        const modalRef = this.ngbModal.open(SuccessDialogComponent);
        modalRef.componentInstance.message =
          "You have successfully updated the equipment standard.";
        if (data == false) {
          modalRef.componentInstance.title = "Error";
          modalRef.componentInstance.message =
            "Some error occurred. Please try again after some time";
        }
        if (data.status == false) {
          modalRef.componentInstance.title = "Error";
        }
        modalRef.componentInstance.nrbesSuccessPopupEmit.subscribe(() => {
          this.ngbModal.dismissAll();
          this.resetForm();
          if (data) {
            this.standardService.nationalEquipmentStandardFiltration = new FilterList();
            const targetRoute = this.equipmentStandard.obsoleteDate
              ? "/view-all-obsolete-standards-list"
              : "/view-all-equipments";
            this.router.navigate([targetRoute]);
          }
        });
      });
    } else {
      this.addStandard(this.equipmentStandard).subscribe((data) => {
        const modalRef = this.ngbModal.open(SuccessDialogComponent);
        modalRef.componentInstance.message =
          "You have successfully added the equipment standard.";
        if (data) {
          this.newCreatedStandard.push({
            name: this.equipmentStandard.title,
            totalTime: this.endTimer(),
            eventType: "NewStandardsPROD",
            status: "Created",
            standardType: "MarketEquipmentStandard",
            session: JSON.parse(localStorage.getItem("NRBA_SESSION")).value,
            error: this.error,
            errorMessage: "No error",
          });
          void 0;
          this.standardService
            .recordEvent(this.newCreatedStandard)
            .subscribe({ next: () => void 0, error: () => void 0 });
        } else {
          modalRef.componentInstance.title = "Error";
          modalRef.componentInstance.message =
            "Some error occurred. Please try again after some time";
        }
        // if (data.status == false) {
        //   modalRef.componentInstance.title = "Error";
        // }
        modalRef.componentInstance.nrbesSuccessPopupEmit.subscribe(() => {
          this.ngbModal.dismissAll();
          if (data) {
            this.standardService.nationalEquipmentStandardFiltration = new FilterList();
            const targetRoute = this.equipmentStandard.obsoleteDate
              ? "/view-all-obsolete-standards-list"
              : "/view-all-equipments";
            this.router.navigate([targetRoute]);
          }
        });
        this.resetForm();
      });
    }
  }

  addStandard(equipmentStandard: EquipmentStandard): Observable<any> {
    this.loading = true;
    return new Observable<any>((observer) => {
      this.equipmentStandardService
        .addEquipmentStandard(equipmentStandard)
        .subscribe(
          (data: any) => {
            this.loading = false;
            observer.next(data);
          },
          (error) => {
            this.loading = false;
            this.newCreatedStandard.push({
              name: this.equipmentStandard.title,
              totalTime: this.endTimer(),
              eventType: "NewStandardsPROD",
              status: "Failed",
              standardType: "MarketEquipmentStandard",
              session: JSON.parse(localStorage.getItem("NRBA_SESSION")).value,
              error: true,
              errorMessage: error.message,
            });
            void 0;
            this.standardService
              .recordEvent(this.newCreatedStandard)
              .subscribe({ next: () => void 0, error: () => void 0 });
            observer.next(false);
          },
        );
    });
  }

  updateStandard(equipmentStandard: EquipmentStandard): Observable<any> {
    this.loading = true;
    return new Observable<any>((observer) => {
      this.equipmentStandardService
        .updateEquipmentStandard(equipmentStandard)
        .subscribe(
          (data: any) => {
            this.loading = false;
            observer.next(data);
          },
          (error) => {
            this.loading = false;

            this.newCreatedStandard.push({
              name: this.equipmentStandard.title,
              totalTime: this.endTimer(),
              eventType: "NewStandardsPROD",
              status: "Failed",
              standardType: "MarketEquipmentStandard",
              session: JSON.parse(localStorage.getItem("NRBA_SESSION")).value,
              error: true,
              errorMessage: error.message,
            });
            void 0;
            this.standardService
              .recordEvent(this.newCreatedStandard)
              .subscribe({ next: () => void 0, error: () => void 0 });
            observer.next(false);
          },
        );
    });
  }

  convertToBaseString(selectedFile): Observable<any> {
    return new Observable<any>((observer) => {
      var fileReader = new FileReader();
      if (fileReader && selectedFile) {
        fileReader.readAsDataURL(selectedFile);
        fileReader.onload = function () {
          observer.next(fileReader.result.toString());
        };
      }
    });
  }

  onRemoveImage() {
    this.equipmentStandard.imageAttachment.id = 0;
    this.equipmentStandard.imageFileName = null;
    this.equipmentStandard.imageAttachmentContentAsBase64 = null;
    this.equipmentStandard.imageAttachment.fileName = null;
    this.equipmentStandard.imageAttachment.attachmentContentAsBase64 = null;
    this.invalidImage = false;
    this.invalidImageRes = false;
    this.addEquipmentStandardForm.controls.image.setValue(null);
  }

  onDownloadSelectedImage(id) {
    if (id) {
      return this.standardService.getAttachmentUrl(id, false).subscribe(
        (response: any) => {
          const blob = new Blob([response], {
            type: response.type,
          });
          if (
            (window.navigator as any) &&
            (window.navigator as any).msSaveOrOpenBlob
          ) {
            (window.navigator as any).msSaveOrOpenBlob(blob);
            return;
          }
          const url = window.URL.createObjectURL(blob);
          window.open(url);
        },
        (error: any) => {
          const modalRef = this.ngbModal.open(FailModuleComponent);
          modalRef.componentInstance.errorMessage = error.error
            ? error.error.Message
            : error.message;
        },
      );
    } else {
      fetch(this.equipmentStandard.imageAttachmentContentAsBase64)
        .then((res) => res.blob())
        .then((blob) => {
          if ((window.navigator as any).msSaveOrOpenBlob) {
            (window.navigator as any).msSaveBlob(
              blob,
              this.equipmentStandard.imageAttachment.fileName,
            );
          } else {
            var a = document.createElement("a");
            a.href = this.equipmentStandard.imageAttachmentContentAsBase64;
            a.setAttribute(
              "download",
              this.equipmentStandard.imageAttachment.fileName,
            );
            a.click();
          }
        });
    }
  }

  onSelectAttachment(event) {
    let selectedFile = event.target.files[0];
    this.invalidAttachment = this.validateAttachmentType(selectedFile.name);
    this.convertToBaseString(selectedFile).subscribe((result) => {
      this.equipmentStandard.equipmentAttachment.id = 0;
      this.equipmentStandard.equipmentAttachment.fileName = selectedFile.name;
      this.equipmentStandard.equipmentAttachment.attachmentContentAsBase64 =
        result;
      event.target.value = null;
    });
  }

  validateAttachmentType(fileName: string) {
    let fileTypeArr = ["doc", "docx", "pdf"];
    if (fileName != null) {
      let fileNameArr = [];
      let splitedFileName = fileName.toLowerCase().split(".");
      splitedFileName.forEach(function (obj) {
        fileNameArr.push(obj);
      });
      fileNameArr = fileNameArr.reverse();
      if (!fileTypeArr.includes(fileNameArr[0])) {
        return true;
      }
      return false;
    }
  }

  onSelectImage(event) {
    this.invalidImageRes = false;
    let selectedFile = event.target.files[0];
    this.imageChangedEvent = event.target.files[0];
    this.invalidImage = this.validateFileType(selectedFile.name);
    if (!this.invalidImage) {
      this.showPrompt().then((result) => {
        void 0;
        if (result == null) {
          this.equipmentStandard.imageAttachmentContentAsBase64 = null;
          event.target.value = null;
          this.equipmentStandard.imageAttachment.fileName = null;
        } else {
          this.equipmentStandard.imageAttachmentContentAsBase64 = result;
          event.target.value = null;
          this.equipmentStandard.imageAttachment.fileName = selectedFile.name;
          this.addEquipmentStandardForm.controls.image.setValue(
            this.equipmentStandard.imageAttachment.fileName,
          );
        }
      });
    }
  }

  validateFileType(fileName: string) {
    let fileTypeArr = ["jpg", "jpeg", "png", "bmp"];
    if (fileName != null) {
      let fileNameArr = [];
      let splitedFileName = fileName.toLowerCase().split(".");
      splitedFileName.forEach(function (obj) {
        fileNameArr.push(obj);
      });
      fileNameArr = fileNameArr.reverse();
      if (!fileTypeArr.includes(fileNameArr[0])) {
        return true;
      }
      return false;
    }
  }

  validateImageResolution(selectedFile, status): Observable<boolean> {
    return new Observable<boolean>((observer) => {
      if (status == false) {
        var url = URL.createObjectURL(selectedFile);
        var img = new Image();
        img.onload = function () {
          if (img.width != img.height) {
            observer.next(true);
          }
        };
        img.src = url;
      }
    });
  }

  onDownloadSelectedAttachment(e) {
    if (e.id) {
      return this.standardService.getAttachmentUrl(e.id, false).subscribe(
        (response: any) => {
          const blob = new Blob([response], {
            type: response.type,
          });
          if (
            (window.navigator as any) &&
            (window.navigator as any).msSaveOrOpenBlob
          ) {
            (window.navigator as any).msSaveOrOpenBlob(blob, e.fileName);
            return;
          }
          var a = document.createElement("a");
          document.body.appendChild(a);

          let url = window.URL.createObjectURL(blob);
          a.href = url;
          a.download = e.fileName;
          a.click();
          window.URL.revokeObjectURL(url);

          //window.open(url);
        },
        (error: any) => {
          const modalRef = this.ngbModal.open(FailModuleComponent);
          modalRef.componentInstance.errorMessage = error.error
            ? error.error.Message
            : error.message;
        },
      );
    } else {
      fetch(e.attachmentContentAsBase64)
        .then((res) => res.blob())
        .then((blob) => {
          if ((window.navigator as any).msSaveOrOpenBlob) {
            (window.navigator as any).msSaveBlob(blob, e.fileName);
          } else {
            let url = window.URL.createObjectURL(blob);
            var a = document.createElement("a");
            a.href = e.attachmentContentAsBase64;
            a.setAttribute("download", e.fileName);
            a.click();
            window.URL.revokeObjectURL(url);
          }
        });
    }
  }

  onRemoveAttachment() {
    this.equipmentStandard.equipmentAttachment.id = 0;
    this.equipmentStandard.attachmentFileName = null;
    this.equipmentStandard.imageAttachmentContentAsBase64 = null;
    this.equipmentStandard.equipmentAttachment.fileName = null;
    this.equipmentStandard.equipmentAttachment.attachmentContentAsBase64 = null;
    this.invalidAttachment = false;
  }

  checkFormValidity() {
    const isEdit = !!(this.equipmentStandard?.id && this.equipmentStandard.id > 0);
    if (
      this.step0Group.invalid ||
      this.step1Group.invalid ||
      this.step2Group.invalid ||
      this.invalidImage ||
      this.invalidAttachment ||
      (!isEdit && this.equipmentStandard?.imageAttachment?.fileName == null) ||
      this.invalidImageRes
    ) {
      return true;
    } else {
      return false;
    }
  }

  resetForm() {
    if (this.isEditMode) {
      this.addEquipmentStandardForm.controls.description.setValue(
        this.equipmentStandard.description,
      );
      this.addEquipmentStandardForm.controls.note.setValue(
        this.equipmentStandard.note,
      );
    } else {
      this.addEquipmentStandardForm.reset();
      this.equipmentStandard.imageFileName = null;
      this.equipmentStandard.imageAttachmentContentAsBase64 = null;
      this.equipmentStandard.imageAttachment.fileName = null;
      this.equipmentStandard.imageAttachment.attachmentContentAsBase64 = null;
      this.invalidImage = false;
      this.equipmentStandard.equipmentAttachment.fileName = null;
      this.equipmentStandard.equipmentAttachment.attachmentContentAsBase64 =
        null;
      this.invalidAttachment = false;
      this.createForm();
    }
  }

  setControlsValue() {
    if (this.equipmentStandard.standardId) {
      //this.equipmentTypes.push(this.equipmentStandard.equipmentType);
      this.addEquipmentStandardForm.controls.equipmentTypeId.setValue(
        this.equipmentStandard.equipmentTypeId,
      );
      this.addEquipmentStandardForm.controls.model.setValue(
        this.equipmentStandard.model,
      );
      this.addEquipmentStandardForm.controls.title.setValue(
        this.equipmentStandard.title,
      );
      this.addEquipmentStandardForm.controls.description.setValue(
        this.equipmentStandard.description,
      );
      this.addEquipmentStandardForm.controls.effectiveFrom.setValue(
        this.equipmentStandard.effectiveFrom,
      );
      this.addEquipmentStandardForm.controls.obsoleteDate.setValue(
        this.equipmentStandard.obsoleteDate == "0001-01-01T00:00:00"
          ? ""
          : this.equipmentStandard.obsoleteDate,
      );
      const note = DOMPurify.sanitize(this.equipmentStandard.note);
      this.addEquipmentStandardForm.controls.note.setValue(note);
      //this.locationTypes.push(this.equipmentStandard.locationType);
      this.addEquipmentStandardForm.controls.locationTypeId.setValue(
        this.equipmentStandard.locationTypeId,
      );
      if (this.equipmentStandard.locationType?.subLocationTypes?.length > 0) {
        //this.subLocationTypes.push(this.equipmentStandard.subLocationType);
        this.addEquipmentStandardForm.controls.subLocationTypeId.setValue(
          this.equipmentStandard.subLocationTypeId,
        );
      }
      //this.suppliers.push(this.equipmentStandard.supplier);
      this.addEquipmentStandardForm.controls.supplierId.setValue(
        this.equipmentStandard.supplierId,
      );

      const linksList =
        this.equipmentStandard.links ||
        (this.equipmentStandard as any).Links ||
        (this.equipmentStandard as any).standard?.links ||
        (this.equipmentStandard as any).standard?.Links;

      if (Array.isArray(linksList) && linksList.length > 0) {
        while (this.resourceLinks1.length > 0) {
          this.resourceLinks1.removeAt(0);
        }
        linksList.forEach((link: any) => {
          const title = link.title ?? link.Title ?? link.name ?? "";
          const url = link.url ?? link.Url ?? "";
          this.resourceLinks1.push(
            this.fb.group({
              url: [url],
              title: [title],
            })
          );
        });
      }
    }
  }

  setLocationEquipmentTypeMapping(locationType) {
    this.addEquipmentStandardForm.controls.locationTypeId.reset();
    this.addEquipmentStandardForm.controls.locationTypeId.setValue(
      locationType.value,
    );
    void 0;
    this.setSublocationsAndSublocationsvalidations(locationType);
  }

  setSubLocation(subLocationType) {
    this.addEquipmentStandardForm.controls.subLocationTypeId.reset();
    this.addEquipmentStandardForm.controls.subLocationTypeId.setValue(
      subLocationType,
    );
  }

  setSublocationsAndSublocationsvalidations(locationType) {
    locationType.map((e) => {
      this.locationTypes.filter((p) => {
        if (e == p.id && p.subLocationTypes.length > 0) {
          void 0;
          this.subLocationTypes = p.subLocationTypes;
          this.sublocationDropdownList = this.subLocationTypes;
        }
      });
    });
    // this.subLocationTypes = this.locationTypes.filter(
    //   (p) => p.id == locationType.value
    // )[0].subLocationTypes;
    if (this.subLocationTypes.length > 0) {
      this.addEquipmentStandardForm.controls.subLocationTypeId.setValidators(
        Validators.required,
      );
      this.addEquipmentStandardForm.controls.subLocationTypeId.updateValueAndValidity();
    } else {
      this.addEquipmentStandardForm.controls.subLocationTypeId.setValidators(
        null,
      );
      this.addEquipmentStandardForm.controls.subLocationTypeId.updateValueAndValidity();
    }
  }

  onBackClickorEditRedirect() {
    this.router.navigate([this.standardService.standardEditPreviousRoute]);
  }

  showPrompt(): Promise<string> {
    return new Promise<string>((resolve) => {
      this.SimpleModalService.addModal(ModalImageCropperComponent, {
        title: "Crop your image",
        ratio: 1,
        event: this.imageChangedEvent,
      }).subscribe((image) => {
        resolve(image);
      });
    });
  }

  onSelectCountry(countryId: number) {
    this.equipmentStandardService
      .getMarketSuppliersByCountryId([countryId])
      .subscribe((data: any) => {
        this.suppliers = data.map((ob) => new Supplier(ob));
      });
  }

  onPasteCleanup(fieldNmae: string) {
    setTimeout(() => {
      const ctrl = this.addEquipmentStandardForm.get(fieldNmae);
      if (!ctrl) return;

      const cleaned = (ctrl.value || "")
        .replace(/[\u00A0\u2000-\u200B]/g, " ")
        .replace(/\s{2,}/g, "  ");

      if (ctrl.value !== cleaned) {
        ctrl.setValue(cleaned, { emitEvent: false });
      }
    }, 0);
  }

  cleanQuillHTML(html: string): string {
    return (
      html
        .replace(/\u00A0|\u202F/g, " ")
        .replace(/\uFEFF/g, "")
        // .replace(/\u200B/g, '')         // Remove zero-width space
        // .replace(/\s+/g, ' ')           // Collapse multiple spaces if needed
        // .replace(/<span[^>]*>(\s*)<\/span>/g, '$1') // Remove empty spans
        .trim()
    );
  }

  onEditorCreated(quill: any) {
    const value = this.addEquipmentStandardForm.get("note")?.value;
    if (value) {
      quill.clipboard.dangerouslyPasteHTML(value);
    }
    quill.root.addEventListener("paste", (event: ClipboardEvent) => {
      const pastedText = event.clipboardData?.getData("text/plain");
      const pastedHtml = event.clipboardData?.getData("text/html");

      // void 0;
      // void 0;
      if (pastedHtml) {
        event.preventDefault();

        const cleanHtml = this.cleanQuillHTML(pastedHtml);
        const delta = quill.clipboard.convert(cleanHtml);

        quill.updateContents(delta, "user");
      }
    });
  }

  onStepChange(event: StepperSelectionEvent): void {
    // this.currentSTepIndex = event.selectedIndex;
  }

  onItemSelect(item: any) {
    const Selectedids = this.selectedLocations.map((x) => {
      return x.id;
    });
    this.setSublocationsAndSublocationsvalidations(Selectedids);
    this.addEquipmentStandardForm.controls.locationTypeId.setValue(Selectedids);
  }

  nextStep(): void {
    if (this.currentSTepIndex == 0) {
      if (this.step0Group.get("title")?.invalid) {
        this.step0Group.get("title")?.markAsTouched();
      }

      if (this.step0Group.get("equipmentTypeId")?.invalid) {
        this.step0Group.get("equipmentTypeId")?.markAsTouched();
      }

      if (this.step0Group.get("supplierId")?.invalid) {
        this.step0Group.get("supplierId")?.markAsTouched();
      }
      if (this.step0Group.get("model")?.invalid) {
        this.step0Group.get("model")?.markAsTouched();
      }
      if (this.step0Group.invalid) {
        return;
      }
    }

    if (this.currentSTepIndex == 1) {
      if (this.step1Group.get("description")?.invalid) {
        this.step1Group.get("description")?.markAsTouched();
      }
      if (this.step1Group.get("locationTypeId")?.invalid) {
        this.step1Group.get("locationTypeId")?.markAsTouched();
      }
      if (this.step1Group.get("subLocationTypeId")?.invalid) {
        this.step1Group.get("subLocationTypeId")?.markAsTouched();
      }
      if (this.step1Group.get("image")?.invalid) {
        this.step1Group.get("image")?.markAsTouched();
      }

      if (this.step1Group.invalid) {
        return;
      }
    }
    if (this.currentSTepIndex == 2) {
      if (this.step2Group.get("note")?.invalid) {
        this.step2Group.get("note")?.markAsTouched();
      }
      if (this.step2Group.get("linksFieldValid")?.invalid) {
        this.step2Group.get("linksFieldValid")?.markAsTouched();
      }

      if (this.step2Group.invalid) {
        return;
      }
    }
    // if (this.currentSTepIndex <= this.formSteps.length - 1) {
    //   this.formSteps[this.currentSTepIndex].status = "completed";
    //   this.currentSTepIndex++;
    //   this.formSteps[this.currentSTepIndex].status = "active";
    // }
    if (this.currentSTepIndex <= this.formSteps.length - 1) {
      this.formSteps[this.currentSTepIndex].status = "completed";
      this.currentSTepIndex++;
      this.formSteps[this.currentSTepIndex].status = "active";
    }
  }
  previousStep(): void {
    if (this.currentSTepIndex > 0) {
      this.formSteps[this.currentSTepIndex].status = "inactive";
      this.currentSTepIndex--;
      this.formSteps[this.currentSTepIndex].status = "active";
    }
  }

  clearAllSelected() {
    this.selectedLocations = [];
    this.addEquipmentStandardForm.controls.locationTypeId.setValue([]);
    // this.locationDropdown.clearAll();   // 🔥 clears UI checkboxes
  }

  onEquipmentSelect(item: any) {
    if (item && item.id) {
      this.selectedEquipmentType = [item];
      this.lastPageEquipmentType = item.name;
      this.addEquipmentStandardForm["controls"].equipmentTypeId.setValue(item.id);
    }
  }

  onEquipmentDeSelect(item: any) {
    if (item && item.id) {
      this.selectedEquipmentType = [item];
      this.lastPageEquipmentType = item.name;
      this.addEquipmentStandardForm["controls"].equipmentTypeId.setValue(item.id);
    }
  }

  onSupplierSelect(item: any) {
    if (item && item.id) {
      this.selectedSupplier = [item];
      this.lastPageSupplier = item.name;
      this.addEquipmentStandardForm["controls"].supplierId.setValue(item.id);
    }
  }

  onSupplierDeSelect(item: any) {
    if (item && item.id) {
      this.selectedSupplier = [item];
      this.lastPageSupplier = item.name;
      this.addEquipmentStandardForm["controls"].supplierId.setValue(item.id);
    }
  }

  onSubLocationSelect(item: any) {
    if (item && item.id) {
      this.subLocationselected = [item];
      this.lastPageSublocation = item.name;
      this.setSubLocation(item.id);
    }
  }

  onSubLocationDeSelect(item: any) {
    if (item && item.id) {
      this.subLocationselected = [item];
      this.lastPageSublocation = item.name;
      this.setSubLocation(item.id);
    }
  }

  checkFormFieldValidations(group: FormGroup) {
    if (this.currentSTepIndex == 0) {
      const { title, equipmentTypeId, supplierId, model } = group.controls;
      return title.valid &&
        equipmentTypeId.valid &&
        supplierId.valid &&
        model.valid
        ? null
        : { stepInvalid: true };
    }
    if (this.currentSTepIndex == 1) {
      const { description, locationTypeId, subLocationTypeId, image } =
        group.controls;
      return description.valid &&
        locationTypeId.valid &&
        subLocationTypeId.valid &&
        image.valid
        ? null
        : { stepInvalid: true };
    }
    if (this.currentSTepIndex == 2) {
      // alert(this.resourceLinksValid);
      const { note, resourceLinks, linksFieldValid } = group.controls;

      // const resourceLinksArray = resourceLinks as FormArray;
      // const linksAreValid =
      //   resourceLinksArray.length > 0 &&
      //   resourceLinksArray.controls.every(
      //     (control) =>
      //       control.get("url")?.valid && control.get("description")?.valid
      //   );

      return note.valid && linksFieldValid?.valid
        ? null
        : { stepInvalid: true };
    }
  }
  onPasteLink(event: ClipboardEvent, link) {
    event.preventDefault();
    const pastedText = event.clipboardData?.getData("text") || "";

    if (!pastedText.includes("mcd.com")) {
      alert("Not a valid URL");
    } else {
      link.get("url")?.setValue(pastedText);
      const url = link.get("url")?.value;
      const title = link.get("title")?.value;
      if (title && url) {
        this.addEquipmentStandardForm.get("linksFieldValid")?.clearValidators();
        this.addEquipmentStandardForm
          .get("linksFieldValid")
          ?.updateValueAndValidity();
      } else {
        this.addEquipmentStandardForm
          .get("linksFieldValid")
          ?.setValidators(Validators.required);
        this.addEquipmentStandardForm
          .get("linksFieldValid")
          ?.updateValueAndValidity();
      }
    }
  }
  toggleDetails() {
    this.detailsExpanded = !this.detailsExpanded;
  }

  getDetails() {
    return this.sanitizer.bypassSecurityTrustHtml(
      this.addEquipmentStandardForm.get("note")?.value,
    );
  }

  openSnackBar() {
    this._snackBar.openFromComponent(SnackbarComponent, {
      duration: 2000,
      data: {
        message: "Object Copied to clipboard!",
      },
    });
  }
  disableTyping(event: KeyboardEvent) {
    if ((event.ctrlKey || event.metaKey) && event.key.toLowerCase() === "v") {
      return;
    }

    const allowedKeys = [
      "Tab",
      "ArrowLeft",
      "ArrowRight",
      "ArrowUp",
      "ArrowDown",
    ];

    if (!allowedKeys.includes(event.key)) {
      event.preventDefault();
    }
  }
  copyText(content: any) {
    void 0;
    navigator.clipboard.writeText(content);
    this.openSnackBar();
  }
  onSelectAll(items: any) {
    void 0;
    // void 0;
    const AllSelectedids = items.map((x) => {
      return x.id;
    });
    this.setSublocationsAndSublocationsvalidations(AllSelectedids);
    this.addEquipmentStandardForm.controls.locationTypeId.setValue(
      AllSelectedids,
    );
  }
}
